import { Form, Input, Button } from "antd";
import { MessageOutlined } from "@ant-design/icons";
import FacebookIcon from "@assets/facebook-icon.svg";
import ZaloIcon from "@assets/zalo-icon.svg";
import ShopeeIcon from "@assets/shopee-icon.svg";
import TiktokIcon from "@assets/tiktok-icon.svg";
import { useLogin } from "./useLogin";
import styles from "./styles.module.less";
import type { FormInstance } from "antd";
import type { LoginFormValues } from "@interfaces/login.interface";

const Login = () => {
  const [form] = Form.useForm();
  const { loading, handleSubmit } = useLogin();

  return (
    <div className={styles.loginContainer}>
      <LeftSection />
      <RightSection form={form} handleSubmit={handleSubmit} loading={loading} />
    </div>
  );
};

export default Login;

const LeftSection = () => {
  return (
    <div className={styles.leftSection}>
      <div className={styles.leftContent}>
        <div className={styles.logoSection}>
          <div className={styles.logoIcon}>
            <MessageOutlined />
          </div>
          <span className={styles.logoText}>FanpageChat</span>
        </div>
        <div className={styles.platformCards}>
          <div
            className={`${styles.platformCard} ${styles.card1}`}
            style={{ background: "#00000010" }}
          >
            <img
              src={FacebookIcon}
              alt="Facebook"
              className={styles.platformIcon}
            />
          </div>
          <div
            className={`${styles.platformCard} ${styles.card2}`}
            style={{ background: "#00000010" }}
          >
            <img src={ZaloIcon} alt="Zalo" className={styles.platformIcon} />
          </div>
          <div
            className={`${styles.platformCard} ${styles.card3}`}
            style={{ background: "#00000010" }}
          >
            <img
              src={ShopeeIcon}
              alt="Shopee"
              className={styles.platformIcon}
            />
          </div>
          <div
            className={`${styles.platformCard} ${styles.card4}`}
            style={{ background: "#00000010" }}
          >
            <div className={styles.tiktokIcon}>
              <img
                src={TiktokIcon}
                alt="Tiktok"
                className={styles.platformIcon}
              />
            </div>
          </div>
        </div>
        <h1 className={styles.heading}>Quản Lý Tất Cả Fanpage Một Nơi</h1>
        <p className={styles.description}>
          Tập trung quản lý và trả lời tin nhắn từ Facebook, Zalo, Shopee và
          TikTok trên một bảng điều khiển duy nhất, giúp bạn tiết kiệm thời gian
          và nâng cao hiệu quả công việc.
        </p>
      </div>
    </div>
  );
};

const RightSection = ({
  form,
  handleSubmit,
  loading,
}: {
  form: FormInstance;
  handleSubmit: (values: LoginFormValues) => void;
  loading: boolean;
}) => {
  return (
    <div className={styles.rightSection}>
      <div className={styles.formWrapper}>
        <div className={styles.formHeader}>
          <h2 className={styles.formTitle}>Đăng nhập</h2>
          <p className={styles.formSubtitle}>
            Chào mừng bạn trở lại! Vui lòng nhập thông tin đăng nhập để tiếp
            tục.
          </p>
        </div>
        <Form
          form={form}
          name="login"
          onFinish={handleSubmit}
          autoComplete="off"
          layout="vertical"
          className={styles.loginForm}
        >
          <Form.Item
            name="username"
            label="Email hoặc tên đăng nhập"
            rules={[
              {
                required: true,
                message: "Vui lòng nhập email hoặc tên đăng nhập",
              },
            ]}
          >
            <Input
              placeholder="Nhập email hoặc tên đăng nhập"
              size="large"
              className={styles.customInput}
              autoComplete="username"
            />
          </Form.Item>
          <Form.Item
            name="password"
            label="Mật khẩu"
            rules={[{ required: true, message: "Vui lòng nhập mật khẩu" }]}
          >
            <Input.Password
              placeholder="Nhập mật khẩu"
              size="large"
              className={styles.customInput}
            />
          </Form.Item>
          <div className={styles.forgotPassword}>
            <a href="#" className={styles.forgotLink}>
              Quên mật khẩu?
            </a>
          </div>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={loading}
              block
              size="large"
              className={styles.submitButton}
            >
              {loading ? "Đang đăng nhập..." : "Đăng nhập"}
            </Button>
          </Form.Item>
        </Form>

        <div className={styles.copyright}>
          © {new Date().getFullYear()} CÔNG TY CỔ PHẦN TẬP ĐOÀN KIDO
        </div>
      </div>
    </div>
  );
};
